import React from 'react';
import clsx from 'clsx';
import styles from './style.module.css';

const ErrorPage: React.FC = () => {
    return (
        <div className={clsx(styles.errorPage)}>
            <h1 className={clsx(styles.errorTitle)}>Something went wrong !</h1>
        </div>
    );
};

export default ErrorPage;